/**
 * @module app.prospection.search.searchCtrl
 */

function slice(val) {
    return String(val).slice(0, 5);
}
const moment = require('moment');
let converter = require('json-2-csv');

function SearchCtrl(
    $scope,
    $window,
    $timeout,
    $uibModal,
    $log,
    Notification,
    storeService,
    departementsService,
    $rootScope,
    userNetworkService,
    userService,
    orderService,
    activitiesService,
    fournisseurService
) {
    // $scope.selectActiveMenu(2);
    let self = this;
    self.element = '';
    self.distance = 10;
    self.geoerror = false;
    self.nomprenom = '';
    self.searchElement = '';
    self.searchFromSector = false;
    self.criterias = {};
    self.moduleIn = {};
    self.moduleNotIn = {};
    self.activityIn = {};
    self.activityNotIn = {};
    self.networkIn = !$rootScope.user.rights['userDevance'] ? {} : {
        '300': false,
        '302': true,
        '304': false,
        '003': false
    };
    self.marketIn = {};
    self.TAIn = {};
    self.providerIn = {};
    self.providerIn = {};
    self.clientStateIn = {};
    self.vipIn = {}
    self.idhIn = {};
    self.moduleInLabels = '';
    self.moduleNotInLabels = '';
    self.activityInLabels = '';
    self.activityNotInLabels = '';
    self.networkLabels = !$rootScope.user.rights['userDevance'] ? '' : 'Devlyx';
    self.stateLabels = '';
    self.marketLabels = '';
    self.TALabels = '';
    self.providerLabels = '';
    self.vipLabels = '';
    self.idhLabels = '';
    self.locationFile = null;
    self.serviceIn = {};
    self.serviceInLabels = '';
    self.serviceNotIn = {};
    self.serviceNotInLabels = '';
    self.services = [];

    self.stateOptions = [
        {id: 'EAIN', label: 'Pré-client', code: 'pre-client', icon: 'fa-check', color: '#5bc0de'},
        {id: 'INST', label: 'Client', code: 'client', icon: 'fa-check-circle-o', color: '#428bca'},
        {id: 'RESI', label: 'Ancien client', code: 'ancien-client', icon: 'fa-close', color: '#f0ad4e'},
        {id: 'EATC', label: 'Prospect', code: 'prospect', icon: 'fa-circle-o', color: '#4f9e4f'},
        {id: 'ANPR', label: 'Ancien Propriétaire', code: 'ancien-proprietaire', icon: 'fa-circle-o', color: '#d9534f'},
        {id: 'EARP', label: 'Attente Reprise', code: 'attente-reprise', icon: 'fa-circle-o', color: '#777777'}
    ];

    self.modules = [
        {id: 'module_tabac', label: 'TABAC'},
        {id: 'module_presse', label: 'PRESSE'},
        {id: 'module_librairie', label: 'LIBRAIRIE'},
        {id: 'module_boulangerie', label: 'BOULANGERIE'},
        {id: 'module_fleuriste', label: 'FLEURISTE'},
        {id: 'module_restauration', label: 'RESTAURATION'},
        {id: 'module_autre', label: 'AUTRE'}
    ];

    self.networks = [
        {id: '300', label: 'Bimedia'},
        {id: '302', label: 'Devlyx'},
        {id: '304', label: 'Futurosoft'},
        {id: '003', label: 'NAP'}
    ];

    self.markets = [
        {id: '001', label: 'Tabac Presse'},
        {id: '002', label: 'Boulangerie'},
        {id: '003', label: 'Autres'},
        {id: '011', label: 'Fleuriste'},
        {id: '012', label: 'Restauration'},
        {id: '014', label: 'Bar'}
    ];

    self.TA = [
        {id: 'A+', label: 'A+'},
        {id: 'A', label: 'A'},
        {id: 'B', label: 'B'},
        {id: 'C', label: 'C'}
    ]

    self.status = [
        {id: '0', label: 'Non'},
        {id: '1', label: 'Oui'}
    ]

    self.activities = activitiesService.list();
    self.providers = fournisseurService.list();


    self.isAdgencyRight = $rootScope.user.rights.adgency;
    self.criterias.activeScreen = self.isAdgencyRight && !$rootScope.user.rights.admin;


    self.selectedChange = (labelArray, listItem, activeItem) => {
        self[labelArray] = [];
        for (const item of Object.keys(activeItem)) {
            if (activeItem[item]) {
                let res = listItem.find(i =>
                    (i.id && i.id.toString() === item) || i === item
                );
                self[labelArray].push(res.label ? res.label : res.fournisseur ? res.fournisseur : res);
            }
        }
        self[labelArray] = self[labelArray].join(', ');
    }

    function geoErrCB(err) {
        $timeout(function() {
            self.geoerror = {
                type: 'error',
                message: "La géolocation n'est pas disponible.",
                cause: err
            };
        });
    }

    self.searchAround = function() {
        let navigator = $window.navigator;
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    var p = position.coords;
                    $timeout(function() {
                        $scope.goTo(
                            '/prospection/store/around',
                            p.latitude + ',' + p.longitude + '?near=' + self.distance * 1000
                        );
                    });
                },
                geoErrCB,
                {
                    timeout: 10000
                }
            );
        }
        else {
            geoErrCB({
                message: "la geolocation n'est pas supportée"
            });
        }
    };

    self.searchAroundAddress = function (){
        storeService.searchAroundAddress(encodeURIComponent(self.address.trim())).then(res => {
            $scope.goTo(
                '/prospection/store/around',
                res.geometry.coordinates[1] + ',' + res.geometry.coordinates[0] + '?near=' + self.distance * 1000 + '&activeScreen=' + self.criterias.activeScreen
            );
        }).catch(function(err) {
            $log.error(err);
            Notification.error(err.data);
        });
    }

    self.searchAroundManyAddress = function (){
        console.log(self.locationFile);
        let data = new Buffer(self.locationFile.split(',')[1], 'base64').toString();
        let record = null;
        converter.csv2jsonAsync(data).then(res => {
            record = res;
            $scope.goTo(
                '/prospection/store/around/many',
                JSON.stringify(record) + '?near=' + self.distance * 1000 + '&activeScreen=' + self.criterias.activeScreen
            );
        });
    }

    $scope.uploadFile = function(){
        var filename = event.target.files[0].name;
        document.getElementsByClassName('custom-file-label')[0].innerHTML = filename;
    };

    self.searchByName = function() {
        if (self.nomprenom) {
            if (self.searchFromSector) {
                storeService.getStoresByUserSectors().then(function(stores) {
                    var filteredStores = [];
                    var storePromise;
                    for (var store of stores) {
                        if (store.hasOwnProperty('customers')) {
                            for (var customer of store.customers) {
                                if (
                                    customer.nom_client.toLowerCase().includes(self.nomprenom.toLowerCase()) ||
                                    customer.prenom_client.toLowerCase().includes(self.nomprenom.toLowerCase())
                                ) {
                                    filteredStores.push(store);
                                }
                            }
                        }
                    }
                    storePromise = storeService.getLastAppointmentsForEachStores(filteredStores);
                    storePromise.then(function(response) {
                        filteredStores = storeService.mapStoresAndLastAppointment(filteredStores, response);
                        storeService.addToLocalStore(filteredStores).then(function() {
                            $scope.goTo('/prospection/store/');
                        });
                    });
                });
            }
            else {
                $scope.goTo('/prospection/store/search', self.nomprenom);
            }
        }
    };

    self.resetCriterias = function() {
        self.criterias = {};
        $rootScope.criterias = null;
    }

    let _initiateCriterias = function() {
        if ($rootScope.criterias) {
            console.log($rootScope.criterias);
            if($rootScope.criterias.contractEndDate)
                self.criterias.contractEndDate = $rootScope.criterias.contractEndDate;
            if($rootScope.criterias.appointmentDate)
                self.criterias.appointmentDate = $rootScope.criterias.appointmentDate;
            if($rootScope.criterias.activeScreen)
                self.criterias.activeScreen = $rootScope.criterias.activeScreen;
            if($rootScope.criterias.name)
                self.criterias.name = $rootScope.criterias.name;
            if($rootScope.criterias.phone)
                self.criterias.phone = $rootScope.criterias.phone;
            if($rootScope.criterias.city)
                self.criterias.city = $rootScope.criterias.city;
            if($rootScope.criterias.codeDebit)
                self.criterias.codeDebit = $rootScope.criterias.codeDebit;
            if($rootScope.criterias.codeCompta)
                self.criterias.codeCompta = $rootScope.criterias.codeCompta;
            if($rootScope.criterias.license)
                self.criterias.license = $rootScope.criterias.license;
            if($rootScope.criterias.custId)
                self.criterias.custId = $rootScope.criterias.custId;
            if($rootScope.criterias.storeId)
                self.criterias.storeId = $rootScope.criterias.storeId;
            if($rootScope.criterias.nim)
                self.criterias.nim = $rootScope.criterias.nim;
            if($rootScope.criterias.siren)
                self.criterias.siren = $rootScope.criterias.siren;
            if($rootScope.criterias.postalCode)
                self.criterias.postalCode = $rootScope.criterias.postalCode;
            if($rootScope.criterias.codeInsee)
                self.criterias.codeInsee = $rootScope.criterias.codeInsee;
            if($rootScope.criterias.codeIris)
                self.criterias.codeIris = $rootScope.criterias.codeIris;
            if($rootScope.criterias.clientState){
                self.criterias.clientState = $rootScope.criterias.clientState;
                for(let state of self.criterias.clientState.split(',')) {
                    self.clientStateIn[state] = true;
                }
                for(let state of self.stateOptions) {
                    if (self.clientStateIn[state.id]) {
                        self.stateLabels += state.label + ', ';
                    }
                }
                self.stateLabels = self.stateLabels ? self.stateLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.market){
                self.criterias.market = $rootScope.criterias.market;
                for(let state of self.criterias.market.split(',')) {
                    self.marketIn[state] = true;
                }
                for(let market of self.markets) {
                    if (self.marketIn[market.id]) {
                        self.marketLabels += market.label + ', ';
                    }
                }
                self.marketLabels = self.marketLabels ? self.marketLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.network){
                self.criterias.network = $rootScope.criterias.network;
                for(let state of self.criterias.network.split(',')) {
                    self.networkIn[state] = true;
                }
                for(let network of self.networks) {
                    if (self.networkIn[network.id]) {
                        self.networkLabels += network.label + ', ';
                    }
                }
                self.networkLabels = self.networkLabels ? self.networkLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.TA){
                self.criterias.TA = $rootScope.criterias.TA;
                for(let state of self.criterias.TA.split(',')) {
                    self.TAIn[state] = true;
                }
                for(let ta of self.TA) {
                    if (self.TAIn[ta.id]) {
                        self.TALabels += ta.label + ', ';
                    }
                }
                self.TALabels = self.TALabels ? self.TALabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.provider) {
                self.criterias.provider = $rootScope.criterias.provider;
                for (let state of self.criterias.provider.split(',')) {
                    self.providerIn[state] = true;
                }
                for (let provider of self.providers) {
                    if (self.providerIn[provider.id]) {
                        self.providerLabels += provider.fournisseur + ', ';
                    }
                }
                self.providerLabels = self.providerLabels ? self.providerLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.vipIn) {
                self.criterias.vipIn = $rootScope.criterias.vipIn;
                for (let state of self.criterias.vipIn.split(',')) {
                    self.vipIn[state] = true;
                }
                for (let s of self.status) {
                    if (self.vipIn[s.id]) {
                        self.vipLabels += s.label + ', ';
                    }
                }
                self.vipLabels = self.vipLabels ? self.vipLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.idhIn) {
                self.criterias.idhIn = $rootScope.criterias.idhIn;
                for (let state of self.criterias.idhIn.split(',')) {
                    self.idhIn[state] = true;
                }
                for (let s of self.status) {
                    if (self.idhIn[s.id]) {
                        self.idhLabels += s.label + ', ';
                    }
                }
                self.idhLabels = self.idhLabels ? self.idhLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.activityIn) {
                self.criterias.activityIn = $rootScope.criterias.activityIn;
                for (let state of self.criterias.activityIn.split(',')) {
                    self.activityIn[state] = true;
                }
                for (let activity of self.activities) {
                    if (self.activityIn[activity]) {
                        self.activityInLabels += activity + ', ';
                    }
                }
                self.activityInLabels = self.activityInLabels ? self.activityInLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.activityNotIn) {
                self.criterias.activityNotIn = $rootScope.criterias.activityNotIn;
                for (let state of self.criterias.activityNotIn.split(',')) {
                    self.activityNotIn[state] = true;
                }
                for (let activity of self.activities) {
                    if (self.activityNotIn[activity]) {
                        self.activityNotInLabels += activity + ', ';
                    }
                }
                self.activityNotInLabels = self.activityNotInLabels ? self.activityNotInLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.moduleIn) {
                self.criterias.moduleIn = $rootScope.criterias.moduleIn;
                for (let state of self.criterias.moduleIn.split(',')) {
                    self.moduleIn[state] = true;
                }
                for (let module of self.modules) {
                    if (self.moduleIn[module.id]) {
                        self.moduleInLabels += module.label + ', ';
                    }
                }
                self.moduleInLabels = self.moduleInLabels ? self.moduleInLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.moduleNotIn) {
                self.criterias.moduleNotIn = $rootScope.criterias.moduleNotIn;
                for (let state of self.criterias.moduleNotIn.split(',')) {
                    self.moduleNotIn[state] = true;
                }
                for (let module of self.modules) {
                    if (self.moduleNotIn[module.id]) {
                        self.moduleNotInLabels += module.label + ', ';
                    }
                }
                self.moduleNotInLabels = self.moduleNotInLabels ? self.moduleNotInLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.rds) {
                self.criterias.rds = $rootScope.criterias.rds;
            }
            if($rootScope.criterias.serviceIn) {
                self.criterias.serviceIn = $rootScope.criterias.serviceIn;
                for (let state of self.criterias.serviceIn.split(',')) {
                    self.serviceIn[state] = true;
                }
                for (let service of self.services) {
                    if (self.serviceIn[service.id]) {
                        self.serviceInLabels += service.label + ', ';
                    }
                }
                self.serviceInLabels = self.serviceInLabels ? self.serviceInLabels.slice(0, -2) : '';
            }
            if($rootScope.criterias.serviceNotIn) {
                self.criterias.serviceNotIn = $rootScope.criterias.serviceNotIn;
                for (let state of self.criterias.serviceNotIn.split(',')) {
                    self.serviceNotIn[state] = true;
                }
                for (let service of self.services) {
                    if (self.serviceNotIn[service.id]) {
                        self.serviceNotInLabels += service.label + ', ';
                    }
                }
                self.serviceNotInLabels = self.serviceNotInLabels ? self.serviceNotInLabels.slice(0, -2) : '';
            }
        }
    }

    self.advanceSearch = function() {
        if (self.criterias.contractEndDate !== undefined) {
            self.criterias.contractEndDate = moment(self.criterias.contractEndDate).isValid() ? moment(self.criterias.contractEndDate).format('YYYY-MM') : null;
        }
        if (self.criterias.appointmentDate !== undefined) {
            self.criterias.appointmentDate = moment(self.criterias.appointmentDate).isValid() ? moment(self.criterias.appointmentDate).format('YYYY-MM-DD') : null;
        }
        if(self.clientStateIn !== undefined){
            self.criterias.clientState = [];
            for (const clie of Object.keys(self.clientStateIn)) {
                if (self.clientStateIn[clie]) {
                    self.criterias.clientState = self.criterias.clientState && Array.isArray(self.criterias.clientState) ? self.criterias.clientState : [];
                    self.criterias.clientState.push(clie);
                }
            }
            self.criterias.clientState = self.criterias.clientState && self.criterias.clientState.length ? self.criterias.clientState.join(',') : '';
        }
        if(self.networkIn !== undefined){
            self.criterias.network = [];
            for (const net of Object.keys(self.networkIn)) {
                if (self.networkIn[net]) {
                    self.criterias.network = self.criterias.network && Array.isArray(self.criterias.network) ? self.criterias.network : [];
                    self.criterias.network.push(net);
                }
            }
            self.criterias.network = self.criterias.network && self.criterias.network.length ? self.criterias.network.join(',') : '';
        }
        if(self.marketIn !== undefined){
            self.criterias.market = [];
            for (const mar of Object.keys(self.marketIn)) {
                if (self.marketIn[mar]) {
                    self.criterias.market = self.criterias.market && Array.isArray(self.criterias.market) ? self.criterias.market : [];
                    self.criterias.market.push(mar);
                }
            }
            self.criterias.market = self.criterias.market && self.criterias.market.length ? self.criterias.market.join(',') : '';
        }
        if(self.providerIn !== undefined){
            self.criterias.provider = [];
            for (const pro of Object.keys(self.providerIn)) {
                if (self.providerIn[pro]) {
                    self.criterias.provider = self.criterias.provider && Array.isArray(self.criterias.provider) ? self.criterias.provider : [];
                    self.criterias.provider.push(pro);
                }
            }
            self.criterias.provider = self.criterias.provider && self.criterias.provider.length ? self.criterias.provider.join(',') : '';
        }
        if(self.TAIn !== undefined){
            self.criterias.TA = [];
            for (const ranking of Object.keys(self.TAIn)) {
                if (self.TAIn[ranking]) {
                    self.criterias.TA = self.criterias.TA && Array.isArray(self.criterias.TA) ? self.criterias.TA : [];
                    self.criterias.TA.push(ranking);
                }
            }
            self.criterias.TA = self.criterias.TA && self.criterias.TA.length ? self.criterias.TA.join(',') : '';
        }
        if (self.moduleIn !== undefined) {
            self.criterias.moduleIn = [];
            for (const mod of Object.keys(self.moduleIn)) {
                if (self.moduleIn[mod]) {
                    self.criterias.moduleIn = self.criterias.moduleIn && Array.isArray(self.criterias.moduleIn) ? self.criterias.moduleIn : [];
                    self.criterias.moduleIn.push(mod);
                }
            }
            self.criterias.moduleIn = self.criterias.moduleIn && self.criterias.moduleIn.length ? self.criterias.moduleIn.join(','): '';
        }
        if (self.moduleNotIn !== undefined) {
            self.criterias.moduleNotIn = [];
            for (const mod of Object.keys(self.moduleNotIn)) {
                if (self.moduleNotIn[mod]) {
                    self.criterias.moduleNotIn = self.criterias.moduleNotIn && Array.isArray(self.criterias.moduleNotIn) ? self.criterias.moduleNotIn : [];
                    self.criterias.moduleNotIn.push(mod);
                }
            }
            self.criterias.moduleNotIn = self.criterias.moduleNotIn && self.criterias.moduleNotIn.length ? self.criterias.moduleNotIn.join(',') : '';
        }
        if(self.activityIn !== undefined){
            self.criterias.activityIn = [];
            for (const act of Object.keys(self.activityIn)) {
                if (self.activityIn[act]) {
                    self.criterias.activityIn = self.criterias.activityIn && Array.isArray(self.criterias.activityIn) ? self.criterias.activityIn : [];
                    self.criterias.activityIn.push(act);
                }
            }
            self.criterias.activityIn = self.criterias.activityIn && self.criterias.activityIn.length ? self.criterias.activityIn.join(',') : '';
        }
        if(self.activityNotIn !== undefined){
            self.criterias.activityNotIn = [];
            for (const act of Object.keys(self.activityNotIn)) {
                if (self.activityNotIn[act]) {
                    self.criterias.activityNotIn = self.criterias.activityNotIn && Array.isArray(self.criterias.activityNotIn) ? self.criterias.activityNotIn : [];
                    self.criterias.activityNotIn.push(act);
                }
            }
            self.criterias.activityNotIn = self.criterias.activityNotIn && self.criterias.activityNotIn.length ? self.criterias.activityNotIn.join(',') : '';
        }
        if(self.vipIn !== undefined){
            self.criterias.vipIn = [];
            for (const vip of Object.keys(self.vipIn)) {
                if (self.vipIn[vip]) {
                    self.criterias.vipIn = self.criterias.vipIn && Array.isArray(self.criterias.vipIn) ? self.criterias.vipIn : [];
                    self.criterias.vipIn.push(vip);
                }
            }
            self.criterias.vipIn = self.criterias.vipIn && self.criterias.vipIn.length ? self.criterias.vipIn.join(',') : '';
        }
        if(self.idhIn !== undefined){
            self.criterias.idhIn = [];
            for (const idh of Object.keys(self.idhIn)) {
                if (self.idhIn[idh]) {
                    self.criterias.idhIn = self.criterias.idhIn && Array.isArray(self.criterias.idhIn) ? self.criterias.idhIn : [];
                    self.criterias.idhIn.push(idh);
                }
            }
            self.criterias.idhIn = self.criterias.idhIn && self.criterias.idhIn.length ? self.criterias.idhIn.join(',') : '';
        }
        if (self.serviceIn !== undefined) {
            self.criterias.serviceIn = [];
            for (const serv of Object.keys(self.serviceIn)) {
                if (self.serviceIn[serv]) {
                    self.criterias.serviceIn = self.criterias.serviceIn && Array.isArray(self.criterias.serviceIn) ? self.criterias.serviceIn : [];
                    self.criterias.serviceIn.push(serv);
                }
            }
            self.criterias.serviceIn = self.criterias.serviceIn && self.criterias.serviceIn.length ? self.criterias.serviceIn.join(','): '';
        }
        if (self.serviceNotIn !== undefined) {
            self.criterias.serviceNotIn = [];
            for (const serv of Object.keys(self.serviceNotIn)) {
                if (self.serviceNotIn[serv]) {
                    self.criterias.serviceNotIn = self.criterias.serviceNotIn && Array.isArray(self.criterias.serviceNotIn) ? self.criterias.serviceNotIn : [];
                    self.criterias.serviceNotIn.push(serv);
                }
            }
            self.criterias.serviceNotIn = self.criterias.serviceNotIn && self.criterias.serviceNotIn.length ? self.criterias.serviceNotIn.join(','): '';
        }
        for (const key of Object.keys(self.criterias)) {
            if (self.criterias[key] === '' || self.criterias[key] === undefined || self.criterias[key] === null) {
                delete self.criterias[key];
            }
        }
        console.log(self.criterias);
        $rootScope.criterias = self.criterias;
        $scope.goTo('/prospection/store/advance_search', new URLSearchParams(self.criterias));
    };

    self.elementList = departementsService.getSelectedList() || [];

    userService.getUsersByRole('RDS').then(res => {
        self.RDS = res;
    });

    self.addElement = function() {
        let index;
        if (isNaN(parseInt(self.element))) {
            self.searchElement = 'city';
            index = self.elementList.indexOf(self.element);
            if (self.element && index < 0) {
                self.elementList.push(self.element);
            }
        }
        else {
            self.searchElement = 'departement';
            let dep = slice(self.element);
            index = self.elementList.indexOf(dep);
            if (self.element && +self.element > 0 && index < 0) {
                self.elementList.push(dep);
            }
        }
        self.element = '';
    };

    self.removeElement = function(dep) {
        if (dep) {
            var index = self.elementList.indexOf(dep);
            if (index > -1) {
                self.elementList.splice(index, 1);
            }
        }
    };

    self.hasStores = function() {
        return storeService.hasStores();
    };
    self.localupdates = function() {
        return storeService.getDirtyIds().length;
    };
    self.dl = false;

    self.message = false;

    var updatedAt = storeService.lastUpdated();
    if (updatedAt && Date.now() - updatedAt.getTime() > 48 * 3600 * 1000) {
        var days = (Date.now() - updatedAt.getTime()) / (24 * 3600 * 1000);
        self.message = {
            type: 'error',
            message: "Vos fiches n'ont pas été mises à jour depuis " + days.toFixed(0) + ' jours'
        };
    }

    self.setSearchElement = function() {
        if (departementsService.getSelectedList()[0].length) {
            self.searchElement = isNaN(parseInt(departementsService.getSelectedList()[0])) ? 'city' : 'departement';
            return true;
        }
        return false;
    };

    self.isWritingSameElementType = function() {
        if (self.elementList.length > 0) {
            return isNaN(parseInt(self.element)) === isNaN(parseInt(self.elementList[0]));
        }
        return true;
    };

    self.downloadAndDisplayStores = function() {
        self.downloadStores().then(function() {
            $scope.goTo('/prospection/store');
        });
    };

    /**
     * Download stores in selected departments
     */
    self.downloadStores = function() {
        if (self.searchElement === '') {
            if (!self.setSearchElement()) {
                return;
            }
        }

        // Check internet connection
        if (!$scope.online) {
            self.message = {
                type: 'error',
                message:
                    "Vous n'êtes pas connecté à internet, vous ne pouvez pas télécharger ou mettre à jour vos fiches"
            };
            return;

        }
        departementsService.save(self.elementList);
        self.dl = {
            percent: 1,
            status: 'primary',
            message: ''
        };
        // Récupération des stores
        return storeService.download(departementsService.getSelectedList(), self.searchElement).then(
            function(stores) {
                $timeout(function() {
                    self.dl = {
                        percent: 100,
                        type: 'success',
                        message: stores.length + ' fiches téléchargées'
                    };
                });
            },
            function(err) {
                self.dl = false;
                self.message = {
                    type: 'error',
                    message: 'Une erreur est survenue lors de la récupération des magasins.',
                    cause: err
                };
            },
            function progress(state) {
                $timeout(function() {
                    self.dl = state;
                });
            }
        );
    };

    /**
     * Remove all stores from DB
     */
    self.clearStores = function() {
        departementsService.save([]);
        storeService.clear().then(function() {
            self.message = {
                type: 'success',
                message: 'La base client a bien été vidée.'
            };
        });
    };
    /**
     * clear the results filters and the map configuration (zoom...)
     *      when a new search is started
     */
    function _clearStoresResultsParameters() {
        if ($rootScope.stores) {
            $rootScope.stores = {};
        }
    }

    _clearStoresResultsParameters();

    function _init() {
        self.userNetwork = $rootScope.userNetwork;
        // $rootScope.orderDiscounts = [];
        // $rootScope.order = orderService.getOrderObject();
        // // Init order to create
        // $rootScope.order.RDSRef = self.userNetwork.user.uid;
        // $rootScope.order.DRVRef = self.userNetwork.user.parent
        //     ? self.userNetwork.user.parent.uid
        //     : self.userNetwork.user.parent;
        if (!self.services.length) {
            storeService.getAllServices()
                .then(services => {
                    services.forEach(service => {
                        self.services.push({id: service.id, label: service.nom});
                    });
                }).then(() => {
                    self.services.sort((stateA, stateB) => {
                        if (stateA.label < stateB.label) {
                            return -1;
                        }
                        if (stateA.label > stateB.label) {
                            return 1;
                        }
                        return 0;
                    });
                }).then(() => {
                    _initiateCriterias();
                });

        }

    }

    _init();

    return self;
}
SearchCtrl.$inject = [
    '$scope',
    '$window',
    '$timeout',
    '$uibModal',
    '$log',
    'Notification',
    'storeService',
    'departementsService',
    '$rootScope',
    'userNetworkService',
    'userService',
    'orderService',
    'activitiesService',
    'fournisseurService'
];

angular.module('app.prospection.search', ['ui.bootstrap.modal'])
    .controller('SearchCtrl', SearchCtrl)
    .directive('readFile', [
        function() {
            return {
                scope: {
                    readFile: '='
                },
                link: function(scope, element, attributes) {
                    element.bind('change', function(changeEvent) {
                        var reader = new FileReader();
                        reader.onload = function(loadEvent) {
                            scope.$apply(function() {
                                scope.readfile = loadEvent.target.result;
                            });
                        };
                        reader.readAsArrayBuffer(changeEvent.target.files[0]);
                    });
                }
            };
        }
    ]).directive('customOnChange', function() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeFunc = scope.$eval(attrs.customOnChange);
            element.bind('change', onChangeFunc);
        }
    };
});;
